/*
 * Restores the "Do Not Sell or Share My Personal Information" link on the
 * privacy policy page (starterbakery.com/pages/privacy-policy).
 *
 * The page contains the placeholder <p id="opt-out-p-id"></p> under the
 * "How to opt out" heading; the script that used to populate it was lost
 * (Shopify's rich-text page editor strips <script> tags on save). This file
 * belongs in the THEME, not the page body, so it can't be stripped again —
 * see fixes/README.md for installation.
 *
 * The paragraph renders from Shopify consent state, shared with the cookie
 * banner (the banner's Accept / "Do not sell" buttons write the same state
 * via the Customer Privacy API):
 *   - not opted out  -> the "Do Not Sell or Share" opt-out link
 *   - opted out      -> a visible confirmation (CA requirement, Jan 1 2026)
 * It re-renders on the API's `visitorConsentCollected` event, so clicking
 * either banner button while on the page updates the paragraph immediately.
 * A Global Privacy Control signal is honored automatically.
 */
(function () {
  'use strict';

  function whenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  whenReady(function () {
    var host = document.getElementById('opt-out-p-id');
    // Self-repair: page editors can discard the empty placeholder paragraph
    // or its id on save. On the privacy policy page, recreate it under the
    // "How to opt out" heading so the link survives content edits.
    if (!host && /\/pages\/privacy-policy\b/.test(location.pathname)) {
      var anchor = Array.prototype.find.call(
        document.querySelectorAll('main p, main h2, main h3'),
        function (el) { return /how to opt out/i.test(el.textContent); }
      );
      if (anchor) {
        host = document.createElement('p');
        host.id = 'opt-out-p-id';
        // Place it after the explanatory paragraph that follows the heading,
        // or directly after the heading itself.
        var after = anchor.nextElementSibling && anchor.nextElementSibling.tagName === 'P'
          ? anchor.nextElementSibling : anchor;
        after.parentNode.insertBefore(host, after.nextSibling);
      }
    }
    if (!host) return;

    // Announce state changes to screen readers (role="status" => polite live
    // region), e.g. when a banner click flips this paragraph to the
    // confirmation text.
    host.setAttribute('role', 'status');

    function optedOut() {
      try {
        return window.Shopify.customerPrivacy.currentVisitorConsent().sale_of_data === 'no';
      } catch (e) {
        return false;
      }
    }

    function setSaleOfData(allowed) {
      // Also set marketing consent, mirroring the cookie banner's opt-out:
      // Shopify forwards marketing/analytics consent to app pixels (Google &
      // YouTube), and sale_of_data alone leaves ad tracking fully granted
      // there (verified: gcs=G111 hits post-opt-out until marketing is
      // revoked too). CCPA "sharing" is cross-context behavioral advertising
      // — the marketing category. Analytics consent is left untouched.
      // visitorConsentCollected also triggers render(); calling it in the
      // callback too is harmless (render is idempotent) and covers API
      // versions where the event doesn't fire for self-initiated changes.
      window.Shopify.customerPrivacy.setTrackingConsent(
        { marketing: allowed, sale_of_data: allowed },
        render
      );
    }

    function makeLink(text, onClick) {
      var link = document.createElement('a');
      link.href = '#';
      link.textContent = text;
      link.addEventListener('click', function (event) {
        event.preventDefault();
        onClick();
      });
      return link;
    }

    function render() {
      host.textContent = '';
      if (optedOut()) {
        var note = document.createElement('strong');
        note.textContent =
          'Your request has been honored: we no longer sell or share your ' +
          'personal information from this browser. This preference is stored ' +
          'in a cookie, so you will need to opt out again if you clear ' +
          'cookies or use a different browser or device. ';
        host.appendChild(note);
        host.appendChild(makeLink('Click here to opt back in.', function () {
          setSaleOfData(true);
        }));
      } else {
        host.appendChild(makeLink('Do Not Sell or Share My Personal Information', function () {
          setSaleOfData(false);
        }));
      }
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error) {
          // Leave the page usable; the CCPA contact-email path still applies.
          console.error('[opt-out-link] consent-tracking-api failed to load:', error);
          return;
        }
        render();
        // Fired whenever consent changes: our link, the cookie banner's
        // Accept / "Do not sell" buttons, or any other CMP interaction.
        document.addEventListener('visitorConsentCollected', render);
        if (navigator.globalPrivacyControl && !optedOut()) {
          setSaleOfData(false);
        }
      }
    );
  });
})();
